import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75a201b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-table" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "form-table-td-count" }, [
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td")
], -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  colspan: "10",
  class: "packages"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "产品信息", -1))
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { colspan: "10" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "附件", -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c","margin-right":"4px"} }, "*", -1))
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0px 0px 20px 20px"} }, "请选择您要执行的动作", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_menu_tab = _resolveComponent("miezz-menu-tab")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_order_detail_company_business_card = _resolveComponent("order-detail-company-business-card")!
  const _component_miezz_text_ellipsis = _resolveComponent("miezz-text-ellipsis")!
  const _component_miezz_page_list = _resolveComponent("miezz-page-list")!
  const _component_order_detail_products_summary = _resolveComponent("order-detail-products-summary")!
  const _component_order_detail_container = _resolveComponent("order-detail-container")!
  const _component_order_detail_cost = _resolveComponent("order-detail-cost")!
  const _component_order_detail_lading_bill = _resolveComponent("order-detail-lading-bill")!
  const _component_miezz_upload = _resolveComponent("miezz-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_miezz_card = _resolveComponent("miezz-card")!
  const _component_miezz_common_history = _resolveComponent("miezz-common-history")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_miezz_form = _resolveComponent("miezz-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_miezz_menu_tab, {
      modelValue: _ctx.menuTab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.menuTab) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_miezz_card, {
      "bottom-buttons": _ctx.buttons,
      onHandleFooterButtonClick: _ctx.handleClick
    }, {
      default: _withCtx(() => [
        (_ctx.form.Data)
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 0,
              model: _ctx.form.Data,
              ref: "ruleForm",
              "label-width": "200px"
            }, {
              default: _withCtx(() => [
                _createElementVNode("table", _hoisted_1, [
                  _hoisted_2,
                  _createVNode(_component_order_detail_company_business_card, {
                    form: _ctx.form,
                    "onUpdate:form": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "业务类型" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.type), 1)
                        ]),
                        _: 1
                      }),
                      (_ctx.form.Data.Status != _ctx.EnumOrderPoolStatus.WaitingAdd)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: "Booking No"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.form.Data.BookingNo), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_form_item, {
                        label: 
                _ctx.logier?.CompanyType == _ctx.EnumCompanyType.ServiceProvider
                  ? '委托方的编号'
                  : '我的编号'
              
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.form.Data.Code ?? "暂无数据"), 1)
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      (_ctx.form.Data.DeparturePortWarehouse)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 1,
                            label: "预计到仓时间",
                            prop: "EstimatedAtWwarehouseDate"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.form.Data.EstimatedAtWwarehouseDate)), 1)
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 2,
                            label: "预计货好时间",
                            prop: "EstimatedGoodsReadyDate"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.form.Data.EstimatedGoodsReadyDate)), 1)
                            ]),
                            _: 1
                          })),
                      _createVNode(_component_el_form_item, {
                        label: "Port of  Loading/装货港",
                        prop: "LoadingPortId"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.form.Data.LoadingPortLabel ?? "暂无数据"), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Port of Discharge/卸货港",
                        prop: "DischargePortId"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.form.Data.DischargePortLabel ?? "暂无数据"), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Port of Delivery/目的港",
                        prop: "DeliveryPortId"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.form.Data.DeliveryPortLabel ?? "暂无数据"), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Place of Delivery/交货地点",
                        prop: "DeliveryPlaceLabel"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.form.Data.DeliveryPlaceLabel ?? "暂无数据"), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "详细地址",
                        prop: "DeliveryPlaceAddress"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.form.Data.DeliveryPlaceAddress ?? "暂无数据"), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "承运人",
                        prop: "CarrierId"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.form.Data.CarrierLabel ?? "暂无数据"), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "渠道",
                        prop: "TransportChannelId"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.form.Data.TransportChannelLabel ?? "暂无数据"), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "合约号",
                        prop: "ContractNo"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.form.Data.ContractNo ?? "暂无数据"), 1)
                        ]),
                        _: 1
                      }),
                      (_ctx.form.Data.TransportType == _ctx.EnumTransportType.Sea)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 3,
                            label: "船名",
                            prop: "ShipName"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.form.Data.ShipName ?? "暂无数据"), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.form.Data.TransportType == _ctx.EnumTransportType.Sea)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 4,
                            label: "航次",
                            prop: "VoyageNumber"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.form.Data.VoyageNumber ?? "暂无数据"), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.form.Data.TransportType == _ctx.EnumTransportType.Air)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 5,
                            label: "航班",
                            prop: "Flight"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.form.Data.Flight ?? "暂无数据"), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.form.Data.TransportType == _ctx.EnumTransportType.Railway)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 6,
                            label: "班次",
                            prop: "RailwayNumber"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.form.Data.RailwayNumber ?? "暂无数据"), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_form_item, {
                        label: "装货港ETD",
                        prop: "EstimatedDepartureDate"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.form.Data.EstimatedDepartureDate)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "目的港ETA",
                        prop: "EstimatedArrivalDate"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.form.Data.EstimatedArrivalDate)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "运费支付方式",
                        prop: "TransportPaymentType"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.transportPaymentType), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "运输类型",
                        prop: "GoodsTransportType"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.goodsTransportType), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "备注",
                        prop: "Remark"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.form.Data.Remark ?? "暂无数据"), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["form"]),
                  (_ctx.form.Data.ShowPackages)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
                        _createElementVNode("td", _hoisted_4, [
                          _hoisted_5,
                          _createVNode(_component_miezz_page_list, {
                            modelValue: _ctx.listPackage,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.listPackage) = $event))
                          }, {
                            column: _withCtx(({ model, row, index }) => [
                              (model.Prop == 'Code')
                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 0,
                                    prop: `Packages[${index}].${model.Prop}`,
                                    "label-width": "0px"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(row.Code ?? "暂无数据"), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["prop"]))
                                : (
                    model.Prop == 'Shapes' && row.ShapesLabel != undefined
                  )
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      onClick: ($event: any) => (_ctx.handleShowModalPackageShapes(row, index))
                                    }, [
                                      _createVNode(_component_miezz_text_ellipsis, {
                                        text: row.ShapesLabel
                                      }, null, 8, ["text"])
                                    ], 8, _hoisted_6))
                                  : (model.Prop == 'GrossWeight')
                                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                                        key: 2,
                                        prop: `Packages[${index}].${model.Prop}`,
                                        "label-width": "0px"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", null, _toDisplayString(row.GrossWeight ?? "暂无数据"), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["prop"]))
                                    : (model.Prop == 'Volume')
                                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                                          key: 3,
                                          prop: `Packages[${index}].${model.Prop}`,
                                          "label-width": "0px"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", null, _toDisplayString(row.Volume ?? "暂无数据"), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["prop"]))
                                      : (
                    model.Prop == 'Products' && row.ProductsLabel != undefined
                  )
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 4,
                                            onClick: ($event: any) => (_ctx.handleShowModalProductsLabel(row, index))
                                          }, [
                                            _createVNode(_component_miezz_text_ellipsis, {
                                              text: row.ProductsLabel
                                            }, null, 8, ["text"])
                                          ], 8, _hoisted_7))
                                        : (model.Prop == 'Quantity')
                                          ? (_openBlock(), _createBlock(_component_el_form_item, {
                                              key: 5,
                                              prop: `Packages[${index}].${model.Prop}`,
                                              "label-width": "0px"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(row.Quantity ?? "暂无数据"), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["prop"]))
                                          : (
                    model.Prop == 'ShipmentId' &&
                    row.ShipmentIdLabel != undefined
                  )
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 6,
                                                onClick: ($event: any) => (_ctx.handleShowModalShipmentIdLabel(row, index))
                                              }, [
                                                _createVNode(_component_miezz_text_ellipsis, {
                                                  text: row.ShipmentIdLabel
                                                }, null, 8, ["text"])
                                              ], 8, _hoisted_8))
                                            : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_order_detail_products_summary, {
                    form: _ctx.form,
                    "onUpdate:form": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form) = $event))
                  }, null, 8, ["form"]),
                  (
            _ctx.form.Data.TransportContainerLoad == _ctx.EnumTransportContainerLoad.FCL
          )
                    ? (_openBlock(), _createBlock(_component_order_detail_container, {
                        key: 1,
                        form: _ctx.form,
                        "onUpdate:form": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form) = $event))
                      }, null, 8, ["form"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_order_detail_cost, {
                    form: _ctx.form,
                    "onUpdate:form": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form) = $event)),
                    hideCosts: 
            !_ctx.powerCodes?.contains(
              'OrderManagement_Pool_Summary_Detail_Costs'
            )
          ,
                    showSupplierCosts: 
            _ctx.powerCodes?.contains(
              'OrderManagement_Pool_Summary_Detail_SupplierCosts'
            )
          ,
                    showSettlementCosts: 
            _ctx.powerCodes?.contains(
              'OrderManagement_Pool_Summary_Detail_SettlementCosts'
            ) && _ctx.form.Data.ClientCompanyBuildSettlementBill
          
                  }, null, 8, ["form", "hideCosts", "showSupplierCosts", "showSettlementCosts"]),
                  (
            _ctx.form.Data.DeparturePortBooking && _ctx.form.Data.DeparturePortLadingBill
          )
                    ? (_openBlock(), _createBlock(_component_order_detail_lading_bill, {
                        key: 2,
                        form: _ctx.form,
                        "onUpdate:form": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form) = $event))
                      }, null, 8, ["form"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("div", null, [
                        _createVNode(_component_miezz_upload, {
                          modelValue: _ctx.form.Data.Files,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.Data.Files) = $event)),
                          prop: "File",
                          preview: true
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["model"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["bottom-buttons", "onHandleFooterButtonClick"]),
    (_ctx.logier?.CompanyType != _ctx.EnumCompanyType.Customer)
      ? (_openBlock(), _createBlock(_component_miezz_common_history, {
          key: 0,
          modelValue: _ctx.histories,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.histories) = $event))
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalPackageShapes,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.modalPackageShapes) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.listPackageShapes.Data,
          ref: "ruleFormPackageShapes",
          class: "rule-form-package-shapes"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_miezz_page_list, {
              modelValue: _ctx.listPackageShapes,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.listPackageShapes) = $event))
            }, {
              column: _withCtx(({ model, row, index }) => [
                (model.Prop == 'Length')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      prop: `Items[${index}].Length`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row[model.Prop] ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'Width')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      prop: `Items[${index}].Width`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row[model.Prop] ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'Height')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 2,
                      prop: `Items[${index}].Height`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row[model.Prop] ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'GrossWeight')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 3,
                      prop: `Items[${index}].GrossWeight`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row[model.Prop] ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'Volume')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 4,
                      prop: `Items[${index}].Volume`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row[model.Prop] ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'Quantity')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 5,
                      prop: `Items[${index}].Quantity`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row[model.Prop] ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalPackageProducts,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.modalPackageProducts) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.listPackageProducts.Data,
          ref: "ruleFormPackageProducts",
          class: "rule-form-package-products"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_miezz_page_list, {
              modelValue: _ctx.listPackageProducts,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.listPackageProducts) = $event))
            }, {
              "column-header": _withCtx(({ model }) => [
                (model.Prop == 'NameZh' || model.Prop == 'NameEn')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _hoisted_12,
                      _createElementVNode("span", null, _toDisplayString(model.Label), 1)
                    ]))
                  : _createCommentVNode("", true),
                (model.Prop == 'UnitPrice' || model.Prop == 'TotalPrice')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("span", null, _toDisplayString(model.Label), 1),
                      _createElementVNode("span", null, "（" + _toDisplayString(_ctx.form.Data.CurrencySystemCode ?? "暂无数据") + "）", 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              column: _withCtx(({ model, row, index }) => [
                (model.Prop == 'NameZh')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      prop: `Items[${index}].NameZh`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row[model.Prop] ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'NameEn')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      prop: `Items[${index}].NameEn`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row[model.Prop] ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'HsCode')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 2,
                      prop: `Items[${index}].HsCode`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row[model.Prop] ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'TradingCountryHsCode')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 3,
                      prop: `Items[${index}].TradingCountryHsCode`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row[model.Prop] ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'SpecName')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 4,
                      prop: `Items[${index}].SpecName`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row[model.Prop] ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'Picture')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 5,
                      prop: `Items[${index}].Picture`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_upload, {
                          modelValue: row.Picture,
                          "onUpdate:modelValue": ($event: any) => ((row.Picture) = $event),
                          preview: true,
                          accept: "image/*",
                          width: "30px",
                          height: "30px"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'Material')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 6,
                      prop: `Items[${index}].Material`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row[model.Prop] ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'Purpose')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 7,
                      prop: `Items[${index}].Purpose`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row[model.Prop] ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'Quantity')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 8,
                      prop: `Items[${index}].Quantity`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row[model.Prop] ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'ChargeUnitEn')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 9,
                      prop: `Items[${index}].ChargeUnitEn`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row[model.Prop] ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'UnitPrice')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 10,
                      prop: `Items[${index}].UnitPrice`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row[model.Prop] ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'TotalPrice')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 11,
                      prop: `Items[${index}].TotalPrice`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row[model.Prop] ?? "暂无数据"), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalPackageShipmentId,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.modalPackageShipmentId) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.currentPackage,
          ref: "ruleFormPackageShipmentId",
          class: "rule-form-package-shipment-id",
          "label-width": "150px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "Shipment ID",
              prop: "ShipmentId"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.currentPackage.ShipmentId ?? "暂无数据"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Reference ID",
              prop: "ReferenceId"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.currentPackage.ReferenceId ?? "暂无数据"), 1)
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentPackage.ReferenceIds, (item, i) => {
              return (_openBlock(), _createBlock(_component_el_form_item, {
                key: i,
                label: `FBA No.${i + 1}`,
                prop: `ReferenceIds[${i}].ReferenceId`,
                class: "package-reference-id"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.ReferenceId ?? "暂无数据"), 1)
                ]),
                _: 2
              }, 1032, ["label", "prop"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalAudit,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.modalAudit) = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_14,
        _createVNode(_component_miezz_form, {
          ref: "form-audit",
          modelValue: _ctx.formAudit,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formAudit) = $event))
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'OrderCode')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  prop: item.Prop,
                  label: item.Label,
                  style: {"margin-bottom":"18px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_input, {
                      modelValue: _ctx.formAudit.Data.OrderCode,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formAudit.Data.OrderCode) = $event)),
                      pattern: "[0-9a-zA-Z]",
                      upperCase: true,
                      trimAll: true,
                      placeholder: "选填，未填写时系统会自动生成订单编号"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true),
            (item.Prop == 'ManagerId')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_select, {
                      modelValue: _ctx.formAudit.Data.ManagerId,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formAudit.Data.ManagerId) = $event)),
                      label: _ctx.formAudit.Data.ManagerLabel,
                      "onUpdate:label": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formAudit.Data.ManagerLabel) = $event)),
                      options: _ctx.managers,
                      clearable: false
                    }, null, 8, ["modelValue", "label", "options"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}